var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusSecondary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 11.1982H13.5V5.19824C13.5 4.64524 13.052 4.19824 12.5 4.19824C11.948 4.19824 11.5 4.64524 11.5 5.19824V11.1982H5.5C4.948 11.1982 4.5 11.6452 4.5 12.1982C4.5 12.7512 4.948 13.1982 5.5 13.1982H11.5V19.1982C11.5 19.7512 11.948 20.1982 12.5 20.1982C13.052 20.1982 13.5 19.7512 13.5 19.1982V13.1982H19.5C20.052 13.1982 20.5 12.7512 20.5 12.1982C20.5 11.6452 20.052 11.1982 19.5 11.1982Z",
    fill: "#6172F3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSecondary);
export default __webpack_public_path__ + "static/media/plus_secondary.3deaab1789c20661bf8ebaf1d14b2597.svg";
export { ForwardRef as ReactComponent };